import {ModalComponents} from 'constants/Modals';
import {Routes} from 'constants/routes';

import React from 'react';

import {faTrash} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {TableBody, TableCell, TableRow} from 'components/TableComponent';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {batch} from 'react-redux';
import {useNavigate} from 'react-router';
import {setModalAC} from 'store/modal/modalSlice';
import {setPageEditorUnassignDataAC} from 'store/pubs/pubSlice';
import {IPageEditorUnassign} from 'typescript/interfaces/PageEditorUnassign';
import PageEditor from 'typescript/models/PageEditor';

interface IProps {
  pubEditors: PageEditor[];
  isAdmin: boolean;
}

export const PageEditorsBody = ({isAdmin, pubEditors}: IProps) => {
  const dispatch = useSetGlobalState();
  const {singlePub} = useGlobalState((state) => state.pubPage);
  const navigate = useNavigate();

  const handleUnassignClick = (pageEditorId: string, nickname: string) => {
    if (!singlePub) return;

    const data: IPageEditorUnassign = {
      editorName: nickname || '',
      editorId: pageEditorId,
      pubName: singlePub.attributes.name,
      pubId: singlePub.id,
      pubEditorsListLength: pubEditors.length,
    };

    batch(() => {
      dispatch(setPageEditorUnassignDataAC(data));
      dispatch(setModalAC(ModalComponents.UNASSIGN_PAGE_EDITOR));
    });
  };

  return (
    <TableBody className="pub-page-editors-table__body">
      {pubEditors.map((pageEditor: PageEditor) => (
        <TableRow className="pub-page-editors-table__body-row" key={pageEditor.id}>
          <TableCell
            className="pub-page-editors-table__body-cell pub-page-editors-table__body-cell--name"
            onClick={() => {
              const uid = pageEditor.attributes.user.id;

              navigate(`${Routes.EDITORS_VIEW}/${uid}`);
            }}
          >
            {pageEditor.attributes.user.nickname || '/'}
          </TableCell>
          <TableCell className="pub-page-editors-table__body-cell">{pageEditor.attributes.user.email || '/'}</TableCell>
          <TableCell className="pub-page-editors-table__body-cell">{pageEditor.attributes.user.phone || '/'}</TableCell>
          {isAdmin && (
            <TableCell className="pub-page-editors-table__body-cell pub-page-editors-table__body-cell--empty">
              <button
                title="Delete pub page editor"
                onClick={() => handleUnassignClick(pageEditor.id, pageEditor.attributes.user.nickname || '')}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </TableCell>
          )}
        </TableRow>
      ))}
    </TableBody>
  );
};
